import { useEffect, useState } from "react";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@material-ui/core";
// import { getAssessments } from './../services/api';

import { FaEdit } from "react-icons/fa";

function OrganizationsTable({ organizations, onEdit }) {
  return (
    <div style={{ padding: "10px", height: "95vh" }}>
      {/* <Button variant="contained" color="primary" className="btn-main-limber mb-15">
        Create Organization
      </Button> */}
      <TableContainer
        component={Paper}
        style={{
          overflow: "auto",
          height: "95%",
        }}
      >
        <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Id</TableCell>
              <TableCell align="left">Name</TableCell>
              <TableCell align="right">Edit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {organizations.map((organization) => {
              return (
                <TableRow key={organization.id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell component="th" scope="row">
                    {organization.id}
                  </TableCell>
                  <TableCell align="left">{organization.name}</TableCell>

                  <TableCell align="right">
                    <FaEdit
                      className="icon-limber"
                      size="1.5em"
                      onClick={(evt) => {
                        onEdit(organization.id);
                      }}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default OrganizationsTable;
